import { FC } from 'react'

import styled from 'styled-components'

import { capitalizeFirstLetter } from 'src/Helpers/layoutHelpers'
import { PrimaryDottedButton } from 'src/Components/Buttons/PrimaryDottedButton'
import { ScheduleSteps } from 'src/Components/PrimaryScheduleTabs'
import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { ModalType } from 'src/Types/ui'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`
const ContainerWithError = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1 0 0;
`

const SubTitle = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`
const ArtistsList = styled(SubTitle)`
  font-weight: 400;
`

interface AdsScheduleGenresProps {
  artists: string[]
}

export const AdsScheduleArtists: FC<AdsScheduleGenresProps> = ({ artists }) => {
  const { setSearch } = useCustomSearchParams()

  const handleClick = (): void => {
    const query = {
      step: ScheduleSteps.SETTINGS,
      modal: ModalType.Artists,
    }
    setSearch(query)
  }

  if (!artists.length) {
    return (
      <PrimaryDottedButton onClick={handleClick}>
        Add similar artists (Optional)
      </PrimaryDottedButton>
    )
  }
  const artistsString = artists
    .map((artist) => capitalizeFirstLetter(artist || ''))
    .join(', ')

  return (
    <Container>
      <ContainerWithError>
        <Wrapper>
          <SubTitle>Similar artists</SubTitle>
          <ArtistsList translate='no'>{artistsString}</ArtistsList>
        </Wrapper>
        <PrimaryDottedButton onClick={handleClick}>Edit</PrimaryDottedButton>
      </ContainerWithError>
    </Container>
  )
}
